import { render } from "./GratitudeMessage.vue?vue&type=template&id=507b4047&scoped=true"
import script from "./GratitudeMessage.vue?vue&type=script&lang=js"
export * from "./GratitudeMessage.vue?vue&type=script&lang=js"

import "./GratitudeMessage.vue?vue&type=style&index=0&id=507b4047&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-507b4047"]])

export default __exports__